/**
 * Created by RSchweber-Koren on 4/11/2017.
 */

import angular from "angular";
import Assert from "tbAssert";

import ElectionFactoryModule from "./ElectionFactory";

import Office from "../Office";
import State from "../State";
import Recipient from "../Recipient";
import OfficeType from "../OfficeType";

const mElectionFactorySvc = new WeakMap();

class OfficeFactory {
    constructor(ElectionFactory) {
        Assert.StrictAssert(ElectionFactory != null, "Assertion Failure: Missing Election Factory Service Dependency");

        mElectionFactorySvc.set(this, ElectionFactory);
    }

    CopyOffice(otherOffice) {
        if (otherOffice == null) {
            return otherOffice;
        }

        return new Office(
            otherOffice.officeId,
            otherOffice.officeType,
            otherOffice.officeDistrict,
            otherOffice.officeState,
            otherOffice.officeElections
        );
    }

    FromServerOffice(serverOffice) {

        if (serverOffice == null) {
            return serverOffice;
        }

        let serverOfficeState = undefined;
        if (angular.isDefined(serverOffice.OfficeState)) {
            serverOfficeState = State.FromServerState(serverOffice.OfficeState);
        }

        let serverOfficeType = OfficeType.FromServerOfficeType(serverOffice.OfficeType);

        let serverOfficeSubscriberData = undefined;
        if ((angular.isDefined(serverOffice.Subscribers)) &&
            (angular.isArray(serverOffice.Subscribers)))
        {
            serverOfficeSubscriberData = serverOffice.Subscribers.map(function(oSub) {
                return Recipient.FromServerRecipient(oSub);
            });
        }

        let clientOffice = new Office(
            serverOffice.OfficeId,
            serverOfficeType,
            serverOffice.District,
            serverOfficeState,
            null, //We need an office object to construct the elections correctly.
            serverOfficeSubscriberData
        );

        let getClientOffice = function() {
            return null;
            // Prevent the circular reference by
            // setting all elections office field to null.
        };

        if (angular.isDefined(serverOffice.Elections)) {
            let clientOfficeElections = serverOffice.Elections.map((serverElection) => mElectionFactorySvc.get(this).FromServerElection(serverElection, getClientOffice));

            Array.prototype.push.apply(clientOffice.officeElections, clientOfficeElections);
        }

        return clientOffice;

    }
}

OfficeFactory.$inject = [
    "ElectionFactory"
];

export default angular
    .module("trackerbase-app.models.factories.office-factory", [
        ElectionFactoryModule
    ])
    .service("OfficeFactory", OfficeFactory)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/OfficeFactory.js
// module id = mkIA
// module chunks = 1